module.exports = __webpack_public_path__ + "static/mock_2-a20ecc54b8ed37f8f016ae88dcba994b.png";